<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <b-icon-diagram2 class="mr-1"></b-icon-diagram2>
      {{ $t('page.title.locale_grid') }}
    </page-header>
    <div class="card questions sygni-grid">
      <div class="card-header">
        <h3 class="card-title">
          <strong>{{$t('title.list')}} </strong>
        </h3>
        <div class="d-flex card-header-pills float-right">
          <b-button @click="createNew()" size="sm" variant="success">
            {{$t('btn.add_new')}}
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <div class="row mt-2">
          <div class="col-12">

            <div class="pagination-wrapper">

              <div class="pagination-right">
                <grid-pagination :total-count="totalCount"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 @load-items="paginationReload"></grid-pagination>
              </div> <!-- #pagination-right-->
            </div> <!-- #pagination-wrapper-->

            <div class="table-responsive">
              <b-table striped show-empty
                       :empty-text="$t('table.no_results')"
                       :busy="isBusy"
                       hover
                       head-variant="dark"
                       outlined
                       :sort-by.sync="orderColumn"
                       :sort-desc.sync="orderDirection"
                       :no-local-sorting="true"
                       :items="items"
                       :fields="fields">

                <template #cell(name)="data">
                  <div>
                      <img :src="require(`@/assets/flags/${data.value.toLowerCase()}.svg`)" class="table-flags mr-1">
                      {{ data.value.toUpperCase() }}
                  </div>
                </template>

                <template #cell(status)="data">
                  <b-badge pill variant="warning" v-if="data.value === 'DRAFT'">{{ $t(data.value) }}</b-badge>
                  <b-badge pill variant="success" v-if="data.value === 'PUBLISHED'">{{ $t(data.value) }}</b-badge>
                  <b-badge pill variant="danger" v-if="data.value === 'DELETED'">{{ $t(data.value) }}</b-badge>
                </template>

                <template #cell(updatedAt)="data">
                 <div>
                   {{data.value | dateFormat('YYYY-MM-DD HH:mm')}}
                 </div>
                </template>

                <template #cell(actions)="data">
                  <div class="table-action--cell">
                    <b-button variant="primary" size="sm" @click="editNew(data.item)" v-if="data.item.status !== 'DELETED'">
                      {{ $t('table.btn.edit') }}
                    </b-button>
                    <b-button variant="danger" size="sm" @click="deleteLocale(data.item)" v-if="data.item.status !== 'DELETED'">
                      {{ $t('table.btn.delete') }} {{ data.value }}
                    </b-button>
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>{{$t('state.loading')}}</strong>
                  </div>
                </template>

              </b-table>
            </div> <!-- #table-responsive-->

            <grid-pagination :total-count="totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>

          </div>
        </div>
      </div> <!-- #card-body-->
    </div> <!-- #card questions sygni-grid-->
  </div>
</template>

<script>





import PageHeader from "../../../../components/page/PageHeader";
import GridPagination from "../../../../components/grid/grid-pagination/GridPagination";
import GridMixin from "../../../../components/grid/GridMixin";
import Vue from "vue";
import CreateLocaleModal from "../components/CreateLocaleModal";
import alertify from "alertifyjs";

export default {
  mixins: [GridMixin],
  components: {
    PageHeader,
    GridPagination
  },
  data() {
    return {
      gridGetUrl: '/api/cms/locale',
      orderColumn: null,
      orderDirection: true,
      fields: [
        {key: 'name', label: this.$t('table.header.name')},
        {key: 'label',  label: this.$t('table.header.label')},
        {key: 'domainGroup',  label: this.$t('table.header.domain_group')},
        {key: 'status', label: this.$t('table.header.status')},
        {key: 'updatedAt', label: this.$t('table.header.updated_at')},
        {key: 'actions', label: this.$t('table.header.actions')},
      ],
      selectOptions: {
        bulkActions: [
          {value: null, text: this.$t('table.bulk.actions')},
          {value: 'delete', text: this.$t('table.bulk.actions.delete')},
        ],
      },
      items: [],
    };
  },
  mounted() {
    this.$on('refresh-dict', () => {
      this.loadItems();
    })
    this.$store.dispatch('translations/getDomainGroups');
  },
  methods: {
    createNew() {
      const
          ModalConstructor = Vue.extend(CreateLocaleModal),
          modal = new ModalConstructor({parent: this});

      modal.name = 'create-locale';
      modal.title = this.$t('modal.title.create_locale');

      modal.submit = () => {
        modal.$v.$touch();

        if (!modal.$v.$invalid) {
          this.$store.dispatch('translations/postLocale', modal.form).then(
              () => {
                alertify.success(this.$t('locale.add.success'));
                this.loadItems();
                modal.hideModal();
              }
          )
        }
      }

      modal.$mount();
    },
    editNew(item) {
      const
          ModalConstructor = Vue.extend(CreateLocaleModal),
          modal = new ModalConstructor({parent: this});

      modal.name = 'create-locale';
      modal.title = this.$t('modal.title.edit_locale');
      modal.form = {...item};

      modal.submit = () => {
        modal.$v.$touch();

        if (!modal.$v.$invalid) {
          this.$store.dispatch('translations/putLocale', modal.form).then(
              () => {
                alertify.success(this.$t('locale.edit.success'));
                this.loadItems();
                modal.hideModal();
              }
          )
        }
      }

      modal.$mount();
    },
    deleteLocale(locale) {
      this.$bvModal.msgBoxConfirm(this.$t('locale.delete.confirmation.title').toString()+' '+locale.name, {
        title: this.$t('locale.delete.confirmation.desc'),
        okTitle: this.$t('locale.delete.btn.confirm'),
        cancelTitle: this.$t('btn.cancel'),
        okVariant: 'danger',
      })
          .then(value => {
            if (value) {
              this.$store.dispatch('translations/deleteLocale',locale.id).then(() => {
                this.loadItems();
              })
            }
          });
    },
  },
  watch: {
  }
}
</script>
